import { useSyncExternalStore } from "react";

/**
 * 「本会话必须先改密」信号(0930 修复:首登强制改密刷新即绕过)。
 *
 * 此前强制改密只存在 LoginPage 的组件内存态里,刷新页面后 token 仍在 localStorage、状态丢失 → 直接进站。
 * 现在服务端对「待改密会话」(token 带 pwc claim)只放行改密 / 登出 / 读 /me,其余回 403 PASSWORD_CHANGE_REQUIRED;
 * 前端这边的置位来源:
 *   · AuthContext 启动:token 的 `pwc` claim(刷新后第一帧即可判定,不等网络);
 *   · AuthContext 启动:GET /me 的 `requirePasswordChange`(老 token 不带 claim 时按账号标记兜底);
 *   · httpClient:任何接口回 PASSWORD_CHANGE_REQUIRED → 置位;
 *   · login() 按登录响应置 / 清;logout() 清。
 * 消费:app/guards/ProtectedRoute —— 置位时整站只渲染改密页。
 */
let required = false;
const listeners = new Set<() => void>();

export function markPasswordChangeRequired(v: boolean): void {
  if (required === v) return;
  required = v;
  for (const l of listeners) l();
}

export function isPasswordChangeRequired(): boolean {
  return required;
}

export function subscribePasswordChangeRequired(l: () => void): () => void {
  listeners.add(l);
  return () => {
    listeners.delete(l);
  };
}

export function usePasswordChangeRequired(): boolean {
  return useSyncExternalStore(
    subscribePasswordChangeRequired,
    isPasswordChangeRequired,
    isPasswordChangeRequired
  );
}

/** 后端改密闸的错误码(JwtFilter 直接写的 403)。 */
export const PASSWORD_CHANGE_REQUIRED_CODE = "PASSWORD_CHANGE_REQUIRED";

/** JWT 里「待改密会话」claim 名(与 api JwtUtil.CLAIM_PWD_CHANGE 同一个字面量)。 */
export const PASSWORD_CHANGE_CLAIM = "pwc";

/** 登录页一次性提示(改密后被要求用新密码重登)。LoginPage 读后即删。 */
export const LOGIN_NOTICE_KEY = "xbgeo-login-notice";
